import React, { useState } from 'react';
import { Layout, Card, Row, Col, Switch, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  LockTwoTone,
  SafetyCertificateTwoTone,
  ArrowRightOutlined,
  ProjectTwoTone,
} from "@ant-design/icons";
import TenantApi from "../../common/Apis/TenantApi";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
const Setting = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const [isChecked, setIsChecked] = useState(decodedToken?.isMultitenancy); // Set your default value here
  const isUserRole = decodedToken?.roles.includes("SYSTEM_USER");
  const isADMIN = decodedToken?.roles.includes("SUPER_ADMIN");

  
  const isSUPERADMIN = decodedToken?.roles.includes("SUPER_ADMIN");
  const isSUPERTenantADMIN = decodedToken?.roles.includes("TENANT_ADMIN");

 
  

  const handleCheckboxChange = () => {
    // Update the state with the new checked value
    setIsChecked((prevChecked) => !prevChecked);

    let formData = JSON.stringify({
      multitenancy: !isChecked,
      tenantApiKey: UserDetails?.tenantDTO?.tenantApiKey,
      tenantName: UserDetails?.tenantDTO?.tenantName,
      enabled: true,
      tenantCode: UserDetails?.tenantDTO?.tenantCode,
    });
    TenantApi.Edittenants(UserDetails?.tenantDTO?.id, formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Updated Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        localStorage.clear();
        setTimeout(() => {
          return navigate("/");
        }, 500);
      })
      .catch((err) => {
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });

  };
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content style={{ margin: "16px 16px 0" }}>
          {" "}
          <div>
            <Row
              gutter={[16, 16]}
              style={{ marginBottom: "20px" }}
            >
              {/* <Col span={24} className={isSUPERADMIN ? '' : 'd-none'}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LockTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Set Permissions
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        set permissions for user roles
                      </div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Link to={"/settings/set-permissions"}>
                        <div
                          className="PermissionsBtn"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <ArrowRightOutlined />
                        </div>
                      </Link>
                    </div>
                  </div>
                </Card>
              </Col> */}
              <Col span={24} className={isSUPERADMIN ? '' : 'd-none'}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LockTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Twilio configurations
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Twilio configurations for Super Admin
                      </div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Link to={"/settings/twilio-configurations"}>
                        <div
                          className="PermissionsBtn"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <ArrowRightOutlined />
                        </div>
                      </Link>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col span={24} className={isSUPERADMIN || isSUPERTenantADMIN ? '' : 'd-none'}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LockTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Currency configurations
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Currency configurations for Super Admin
                      </div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Link to={"/settings/currency-configurations"}>
                        <div
                          className="PermissionsBtn"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <ArrowRightOutlined />
                        </div>
                      </Link>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col span={24} className={isSUPERADMIN || isSUPERTenantADMIN ? '' : 'd-none'}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LockTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Sensor Api configurations
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Sensor Api configurations for Super Admin
                      </div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Link to={"/settings/sensor-configurations"}>
                        <div
                          className="PermissionsBtn"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <ArrowRightOutlined />
                        </div>
                      </Link>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col span={24} className={isSUPERADMIN ? '' : 'd-none'}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LockTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Setup Time configurations
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Time Api configurations for Super Admin
                      </div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Link to={"/settings/time-configurations"}>
                        <div
                          className="PermissionsBtn"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <ArrowRightOutlined />
                        </div>
                      </Link>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col span={24} className={isSUPERADMIN ? '' : 'd-none'}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LockTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Video Url configurations
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Video Url URL configurations for Super Admin
                      </div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Link to={"/settings/video-configurations"}>
                        <div
                          className="PermissionsBtn"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <ArrowRightOutlined />
                        </div>
                      </Link>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col span={24} className={isSUPERADMIN ? '' : 'd-none'}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LockTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Setup Terms configurations
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Terms Api configurations for Super Admin
                      </div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <Link to={"/settings/terms-configurations"}>
                        <div
                          className="PermissionsBtn"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#001529",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            padding: "5px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <ArrowRightOutlined />
                        </div>
                      </Link>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginBottom: "20px" }} >
              <Col span={24} className={isUserRole ? 'd-none' : ''}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ProjectTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Enable multi tenancy
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Enable multi tenancy
                      </div>
                    </div>
                    <Switch style={{ marginLeft: 'auto' }} checked={isChecked} onChange={handleCheckboxChange} />

                  </div>
                </Card>
              </Col>
              <Col span={24}>
                <Card style={{ borderRadius: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <SafetyCertificateTwoTone
                      style={{ fontSize: "24px", marginRight: "10px" }}
                    />
                    <div>
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        Two Factor Authentication (2FA)
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        By enabling 2FA, you can enhance the security of your
                        account and protect it from unauthorized access.
                      </div>
                    </div>
                    <Switch style={{ marginLeft: "auto" }} checked />
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Setting;